import { useState } from "react";

import { useCalendarContext } from "Bands/contexts";
import { IEvent } from "Bands/types";
import { DeleteEventModal } from "Bands/containers";

import { CalendarListTable } from ".";

export const CalendarListView = () => {
  const { refetchEvents } = useCalendarContext();

  const [deleteEvent, setDeleteEvent] = useState<IEvent | null>(null);

  return (
    <>
      <CalendarListTable handleDelete={setDeleteEvent} hideCurrentEvent />
      {!!deleteEvent && (
        <DeleteEventModal
          handleClose={() => setDeleteEvent(null)}
          forceDeleteEvent={deleteEvent ?? undefined}
          onDeleteSuccess={refetchEvents}
        />
      )}
    </>
  );
};
